module.exports = __webpack_public_path__ + "static/assets/57507ecce9efed03229d8a5b626666a6.png";